import cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";

export const useLocalize = () => {
  const currentLanguageCode = cookies.get("i18next") || "ar";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
  const { t } = useTranslation();

  const getStylePath = useCallback(() => {
    if (currentLanguage?.dir === "rtl")
      return process.env.PUBLIC_URL + "/assets/css/bootstrap.rtl.min.css";
    return process.env.PUBLIC_URL + "/assets/css/bootstrap.min.css";
  }, [currentLanguage]);

  const [stylePath, setStylePath] = useState(getStylePath);

  useEffect(() => {
    const html = document.documentElement;
    html.dir = currentLanguage?.dir ?? "ltr";
    html.lang = currentLanguage?.code ?? "en";
    setStylePath(getStylePath);
  }, [currentLanguage, t, getStylePath]);

  return { currentLanguage, languages, stylePath, currentLanguageCode };
};

const languages = [
  {
    code: "en",
    name: "English",
    country_code: "gb",
  },
  {
    code: "ar",
    name: "العربية",
    dir: "rtl",
    country_code: "sa",
  },
];
